function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "translation_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "translation_svg__a",
  transform: "translate(47 101)",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "translation_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "translation_svg__c",
  d: "M5.667 8.156a10.151 10.151 0 01-1.889 3.174 4.254 4.254 0 001.4.885l-.315.825a5.228 5.228 0 01-1.736-1.1 4.261 4.261 0 01-2.485.987l-.043-.885a3.373 3.373 0 001.932-.757 7.159 7.159 0 01-1.268-2.459l.859-.221a6.472 6.472 0 001.055 2.076 9.18 9.18 0 001.532-2.527H0v-.868h2.929v-1h.834v1H6.69v.868H5.669M13.291.928l2.689 6.646h-1.055l-.928-2.281h-2.323l-.919 2.281H9.7L12.389.928h.9m.34 3.446l-.791-1.957-.791 1.957zM1.498 4.672A6.834 6.834 0 017.65.783a6.251 6.251 0 01.689.043l.145-.825 1.719 1.736-2.144.706.128-.74a5.53 5.53 0 00-.536-.026 5.945 5.945 0 00-5.344 3.378l-.808-.383M15.083 10.358a6.863 6.863 0 01-5.514 4.748c-.23.026-.46.051-.689.06L8.863 16l-1.957-1.464 2.017-1.013-.017.749a6.23 6.23 0 00.528-.051 5.936 5.936 0 004.8-4.127c.281.085.562.17.851.264"
}));

function SvgTranslation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgTranslation;